
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import Popup from 'reactjs-popup';
import { Container, Alert, Button } from "react-bootstrap";

import Ferie from './Ferie';
import TabellaFerie from './TabellaFerie';
import Permesso from './Permesso';
import ChiusuraAziendale from './ChiusuraAziendale';
import EliminaChiusuraAziendale from './EliminaChiusuraAziendale';
import EliminaFerie from './EliminaFerie';
import ConflictModal from './ConflictModal';
import { buildUrl } from '../helper/handler';
import { getFromApi, postToApi } from '../utilities/NetUtilities';
import { sortLavoratori } from '../utilities/CommonUtilities';

import moment from 'moment';

import '../css/App.css';

function FeriePermessi() {

    const location = useLocation();

    const [message, setMessage] = useState([]);
    const [lavoratori, setLavoratori] = useState([]);
    const [lavoratore, setLavoratore] = useState(null);
    const [dataFiltro, setDataFiltro] = useState(moment(new Date()).format('YYYY-MM-DD'));
    const [openFerie, setOpenFerie] = useState(false);
    const [openPermesso, setOpenPermesso] = useState(false);
    const [openChiusuraAziendale, setOpenChiusuraAziendale] = useState(false);
    const [openEliminaChiusuraAziendale, setOpenEliminaChiusuraAziendale] = useState(false);
    const [ferie, setFerie] = useState([]);
    const [value, setValue] = useState(null);
    const [showConflictModal, setShowConflictModal] = useState(false);
    const [conflictData, setConflictData] = useState(null);

    useEffect(() => {
        // INIZIALIZZA IL LAVORATORE SE PRESENTE NELLA URL
        const queryParams = new URLSearchParams(location.search);
        const lavoratoreIdParam = queryParams.get('lavoratoreid');
        if (lavoratoreIdParam) {
            const lavoratoreNomeParam = queryParams.get('lavoratorenome');
            setLavoratore({ value: lavoratoreIdParam, label: lavoratoreNomeParam });
        }
    }, [location.search]);

    const refreshData = useCallback(() => {
        const organizzazione = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        const setLavoratoriFromApi = (data) => {
            setLavoratori(sortLavoratori(data.lavoratori).map(lavoratore => ({
                "value": lavoratore.id,
                "label": lavoratore.nomeCognome
            })));
        };
        const setMessageFromApi = (data) => {
            setMessage([{ tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione }]);
        };
        if (organizzazione) {
            getFromApi(buildUrl('lavoratori', {
                organizzazione: organizzazione.nome,
                tipo: organizzazione.tipo
            }), setLavoratoriFromApi, setMessageFromApi);
            //setOrganizzazione(organizzazioneMap);
        }
        if (lavoratore) {
            const setFerieFromApi = (data) => {
                if (data.ferie) { setFerie(data.ferie) };
            }
            const request = {
                organizzazione: organizzazione.nome,
                tipoOrganizzazione: organizzazione.tipo,
                lavoratore: lavoratore?.value,
                inizio: dataFiltro
            }
            getFromApi(buildUrl('ferie', request), setFerieFromApi, setMessageFromApi);
        }
    }, [dataFiltro, lavoratore]);

    useEffect(() => {
        refreshData();
    }, [refreshData]);

    const setMessageFromApi = (data) => {
        setMessage([{ tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione }]);
    };

    const okAdd = (data) => {
        setMessageFromApi(data)
        refreshData();
        setOpenPermesso(false);
        setOpenFerie(false)
        setOpenChiusuraAziendale(false);
        setOpenEliminaChiusuraAziendale(false);
        setValue(null);
    }

    const okEdit = (data) => {
        setMessageFromApi(data)
        refreshData();
        setOpenPermesso(false);
        setOpenFerie(false)
        setOpenChiusuraAziendale(false);
        setOpenEliminaChiusuraAziendale(false);
        setValue(null);
    }

    const addFerie = (inizio, fine, id, forceOverride = false) => {
        setMessage([])
        const organizzazione = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        const url = buildUrl('addFerie');
        const newFerie = {
            inizio: inizio,
            fine: fine,
            tipo: "ferie",
            lavoratore: lavoratore.value,
            organizzazione: organizzazione.nome,
            tipoOrganizzazione: organizzazione.tipo,
            id: id,
            forceOverride: forceOverride
        }
        
        const handleResponse = (data) => {
            if (data.requiresConfirmation && !forceOverride) {
                // Mostra modal con conflitti
                setConflictData({
                    ...data,
                    operationType: 'ferie',
                    inizio: inizio,
                    fine: fine,
                    id: id
                });
                setShowConflictModal(true);
            } else {
                // Procede normalmente o conferma override
                const ok = id ? okEdit : okAdd;
                ok(data);
            }
        };
        
        postToApi(url, newFerie, handleResponse, setMessageFromApi);
    }

    const addPermesso = (inizio, fine, id, forceOverride = false) => {
        setMessage([]);
        const organizzazione = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        const url = buildUrl('addFerie');
        const newFerie = {
            inizio: inizio,
            fine: fine,
            tipo: "permesso",
            lavoratore: lavoratore.value,
            organizzazione: organizzazione.nome,
            tipoOrganizzazione: organizzazione.tipo,
            id: id,
            forceOverride: forceOverride
        }
        
        const handleResponse = (data) => {
            if (data.requiresConfirmation && !forceOverride) {
                // Mostra modal con conflitti
                setConflictData({
                    ...data,
                    operationType: 'permessi',
                    inizio: inizio,
                    fine: fine,
                    id: id
                });
                setShowConflictModal(true);
            } else {
                // Procede normalmente o conferma override
                const okAction = id ? okEdit : okAdd;
                okAction(data);
            }
        };
        
        postToApi(url, newFerie, handleResponse, setMessageFromApi);
    }

    const addChiusuraAziendale = (inizio, fine, id, forceOverride = false) => {
        setMessage([]);
        const organizzazione = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        const url = buildUrl('addChiusuraAziendale');
        const newChiusura = {
            inizio: inizio,
            fine: fine,
            tipo: "ferie",
            organizzazione: organizzazione.nome,
            tipoOrganizzazione: organizzazione.tipo,
            id: id,
            forceOverride: forceOverride
            // Nessun campo lavoratore - verrà applicato a tutti
        }
        
        const handleResponse = (data) => {
            if (data.requiresConfirmation && !forceOverride) {
                // Mostra modal con conflitti
                setConflictData({
                    ...data,
                    operationType: 'chiusura_aziendale',
                    inizio: inizio,
                    fine: fine,
                    id: id
                });
                setShowConflictModal(true);
            } else {
                // Procede normalmente o conferma override
                const okAction = id ? okEdit : okAdd;
                okAction(data);
            }
        };
        
        postToApi(url, newChiusura, handleResponse, setMessageFromApi);
    }

    const deleteChiusuraAziendale = (inizio, fine, forceOverride = false) => {
        setMessage([]);
        const organizzazione = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        const url = buildUrl('eliminaChiusuraAziendale');
        const deleteRequest = {
            inizio: inizio,
            fine: fine,
            organizzazione: organizzazione.nome,
            tipoOrganizzazione: organizzazione.tipo,
            forceOverride: forceOverride
        }
        
        const handleResponse = (data) => {
            if (data.requiresConfirmation && !forceOverride) {
                setConflictData({
                    ...data,
                    operationType: 'delete_chiusura_aziendale',
                    inizio: inizio,
                    fine: fine
                });
                setShowConflictModal(true);
            } else {
                okAdd(data);
            }
        };
        
        postToApi(url, deleteRequest, handleResponse, setMessageFromApi);
    }

    const lavoratoreChanged = (lavoratore) => {
        setMessage([])
        setFerie([])
        setLavoratore(lavoratore)
    }

    const dataChanged = (data) => {
        setMessage([]);
        setFerie([]);
        setDataFiltro(data);
    }

    const editFeriePermesso = (object) => {
        setMessage([])
        setValue(object);
        if (object.tipo === "FERIE") {
            setOpenFerie(true);
        } else if (object.tipo === "PERMESSO") {
            setOpenPermesso(true);
        }
    }

    const deleteAction = (data) => {
        setMessage([])
        setMessageFromApi(data)
        setFerie(ferie.filter(actual => actual.id !== data.id))
    }

    const deleteFerie = (ferie, close) => {
        setMessage([])
        const urlElimina = buildUrl('eliminaFerie');
        postToApi(urlElimina, { id: ferie.id }, deleteAction, setMessageFromApi);
        close();
    }
    
    const handleConfirmOverride = () => {
        // Salva i dati prima di chiudere il modal
        const operationType = conflictData.operationType;
        const inizio = conflictData.inizio;
        const fine = conflictData.fine;
        const id = conflictData.id;
        
        // Chiudi il modal prima della chiamata
        setShowConflictModal(false);
        setConflictData(null);
        
        // Chiamata con forceOverride = true
        if (operationType === 'ferie') {
            addFerie(inizio, fine, id, true);
        } else if (operationType === 'permessi') {
            addPermesso(inizio, fine, id, true);
        } else if (operationType === 'chiusura_aziendale') {
            addChiusuraAziendale(inizio, fine, id, true);
        } else if (operationType === 'delete_chiusura_aziendale') {
            deleteChiusuraAziendale(inizio, fine, true);
        }
    };

    const handleCancelOverride = () => {
        setShowConflictModal(false);
        setConflictData(null);
    };

    const openDelete = (trigger, value) => (
        <Popup
            trigger={trigger}
            position="bottom center"
            id={`eliminaferie`}
            modal>
            {close => (
                <EliminaFerie
                    setMessage={setMessage}
                    ferie={value}
                    close={close}
                    action={deleteFerie} />
            )}
        </Popup>
    )

    return <div className='main' role="main">
        <div>
            <h1 className="d-flex justify-content-center inEvidenza" id="title_home">Ferie e permessi</h1>
            {message && !openPermesso && !openFerie && !openChiusuraAziendale && message.map((data, key) => (
                <Alert variant={data.tipo} id="message" key={key}>
                    {data.descrizione}
                </Alert>
            ))}
            <Container>
                <div id="filtro" className='row d-flex justify-content-center align-items-center'>
                    <div className="col-auto">
                        <div className="date-field">
                            <label htmlFor="lavoratore" className="inEvidenza">lavoratore</label>
                            <Select
                                name="lavoratore"
                                instanceId="lavoratore"
                                options={lavoratori}
                                onChange={lavoratoreChanged}
                                placeholder="Seleziona..."
                                value={lavoratore}
                            />
                        </div>
                    </div>
                    <div className="col-auto">
                        <div className="date-field">
                            <label htmlFor="data" className="inEvidenza">a partire da</label>
                            <input
                                className='form-control'
                                id="data"
                                type="date"
                                value={dataFiltro}
                                onChange={(event) => {
                                    dataChanged(event.target.value);
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-auto d-flex gap-2">
                        <Button
                            className="btnGenerale"
                            variant="flat" size="sm"
                            id="aggiungiferie"
                            disabled={lavoratore === null}
                            onClick={() => {
                                setOpenFerie(true);
                                setMessage([]);
                            }}>aggiungi ferie</Button>
                        <Ferie
                            open={openFerie}
                            annulla={() => { setOpenFerie(false); setValue(null); setMessage([]) }}
                            conferma={addFerie}
                            value={value}
                            message={openFerie ? message : []}></Ferie>
                        <Button
                            className="btnGenerale"
                            variant="flat"
                            size="sm"
                            id="aggiungipermesso"
                            disabled={lavoratore === null}
                            onClick={() => {
                                setOpenPermesso(true);
                                setMessage([]);
                            }}>aggiungi permesso</Button>
                        <Permesso
                            open={openPermesso}
                            annulla={() => { setOpenPermesso(false); setValue(null); setMessage([]) }}
                            conferma={addPermesso}
                            value={value}
                            message={openPermesso ? message : []}></Permesso>
                        <Button
                            className="btnGenerale"
                            variant="flat"
                            size="sm"
                            id="aggiungichiesuraazienda"
                            onClick={() => {
                                setOpenChiusuraAziendale(true);
                                setMessage([]);
                            }}>chiusura aziendale</Button>
                        <ChiusuraAziendale
                            open={openChiusuraAziendale}
                            annulla={() => { setOpenChiusuraAziendale(false); setValue(null); setMessage([]) }}
                            conferma={addChiusuraAziendale}
                            value={value}
                            message={openChiusuraAziendale ? message : []}></ChiusuraAziendale>
                        <Button
                            className="btnGenerale"
                            variant="flat"
                            size="sm"
                            id="eliminachiusuraazienda"
                            onClick={() => {
                                setOpenEliminaChiusuraAziendale(true);
                                setMessage([]);
                            }}>elimina chiusura aziendale</Button>
                        <EliminaChiusuraAziendale
                            open={openEliminaChiusuraAziendale}
                            annulla={() => { setOpenEliminaChiusuraAziendale(false); setValue(null); setMessage([]) }}
                            conferma={deleteChiusuraAziendale}
                            message={openEliminaChiusuraAziendale ? message : []}></EliminaChiusuraAziendale>
                    </div>
                </div>
                <div>
                    {ferie.length !== 0 && lavoratore && <TabellaFerie
                        ferie={ferie} edit={editFeriePermesso} openDelete={openDelete} />}
                    {ferie.length === 0 && lavoratore && <span>non sono presenti ferie o permessi</span>}
                </div>
            </Container>
            
            <ConflictModal 
                show={showConflictModal}
                conflicts={conflictData?.conflicts || []}
                onConfirm={handleConfirmOverride}
                onCancel={handleCancelOverride}
                message={conflictData?.detailedMessage}
                operationType={conflictData?.operationType || 'ferie'}
            />
        </div>
    </div>
}

export default FeriePermessi;